<template>
  <div>
    <Head title="Processor Deals" />
    <h1 class="mb-8 text-3xl font-bold">Processor Deals</h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Processor</th>
            <th class="pb-4 pt-6 px-6">Lead</th>
            <th class="pb-4 pt-6 px-6">Loan Officer</th>
            <th class="pb-4 pt-6 px-6">Date / Time</th>
          </tr>
        </thead>
        <tr v-for="deal in deals.data" :key="deal.id" class="even:bg-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t pb-4 pt-4 px-6">
            {{ deal.processor_name }}
          </td>
          <td class="border-t pb-4 pt-4 px-6 cursor-pointer text-indigo-500">
            <Link class="flex items-center" :href="`/leads/${deal.lead_id}/edit`" tabindex="-1">
              <i class="far fa-edit text-indigo-500" /> {{ deal.lead_name }}
            </Link>
          </td>
          <td class="border-t pb-4 pt-4 px-6">
            {{ deal.loan_officer_name }}
          </td>
          <td class="border-t pb-4 pt-4 px-6">
            <div class="px-3 md:p-0 flex flex-col">
              {{ datestamp(deal.created_at) }} at {{ timestamp(deal.created_at) }}
            </div>
          </td>
          <td class="w-px border-t">
            <button v-if="auth.user.owner" class="text-red-600 px-2 pr-6 hover:underline" tabindex="-1" type="button" @click="destroy(deal.id)"><i class="ml-2 far fa-trash-alt text-red-500" /></button>
          </td>
        </tr>
        <tr v-if="deals.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No Deals Found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="deals.links" />
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import moment from 'moment'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    deals: Object,
    auth: Object,
  },
  methods: {
    timestamp : function (date) {
      return moment(date).format('h:mm A')
    },
    datestamp : function (date) {
      return moment(date).format('MM/DD/YY')
    },
    destroy(id) {
      console.log(id)
      if (confirm('Are you sure you want to delete this Processor Assignment?')) {
        router.delete('/processorDeals/'+id ,{only: ['deals'], preserveScroll: true })
      }
    },
  }
}
</script>
